import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useLanguage } from '../contexts/LanguageContext';

const ForgotPasswordPage = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Use current origin for redirect URL (works for both dev and production)
    const redirectUrl = `${window.location.origin}/reset-password`;

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: redirectUrl
    });

    setLoading(false);
    if (error) {
      console.error('Password reset error:', error);
      setError(error.message || t('failedToSendResetEmail'));
    } else {
      setSuccess(t('checkEmailResetLink'));
    }
  };

  return (
    <div style={{ maxWidth: 420, margin: '96px auto', background: '#fff', borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', padding: '2.5rem 2rem', textAlign: 'center' }}>
      <h2 style={{ marginBottom: 24, color: '#2c6e49', fontWeight: 600 }}>{t('forgotPassword')}</h2>
      <p style={{ marginBottom: 24, color: '#666', lineHeight: 1.5 }}>
        {t('forgotPasswordDescription')}
      </p>
      {error && <div style={{ color: '#e57373', marginBottom: 16 }}>{error}</div>}
      {success && <div style={{ color: '#56ab2f', marginBottom: 16 }}>{success}</div>}
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder={t('email')}
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{ width: '100%', padding: '0.8rem', marginBottom: 20, borderRadius: 8, border: '1px solid #ccc', fontSize: '1rem', fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif', boxSizing: 'border-box' }}
          autoFocus
        />
        <button
          type="submit"
          className="btn btn-primary"
          style={{ width: '100%', padding: '0.9rem', fontWeight: 600, fontSize: '1.1rem', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #a8e063 0%, #56ab2f 100%)', color: '#fff', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, boxShadow: '0 2px 8px rgba(86, 171, 47, 0.2)', transition: 'all 0.2s ease-in-out', marginBottom: 16 }}
          disabled={loading}
        >
          {loading ? t('sending') : t('sendResetLink')}
        </button>
      </form>
      <div style={{ marginTop: 16 }}>
        <a href="/login" style={{ color: '#56ab2f', textDecoration: 'underline', fontWeight: 500 }}>{t('backToLogin')}</a>
      </div>
    </div>
  );
};

export default ForgotPasswordPage; 